import { EMPTY_FORMIO_FORM } from '../constants/form-io.constants';

const isPlainObject = (value) =>
  Boolean(value) && typeof value === 'object' && !Array.isArray(value);

const buildEmptyFormioForm = () => ({ ...EMPTY_FORMIO_FORM });

const buildFormioFormFromComponents = (schema) => ({
  ...EMPTY_FORMIO_FORM,
  ...schema,
  components: schema.components,
});

/**
 * Normalize API `schema` into a Form.io form JSON (`display`, `components`, …).
 * Legacy RJSF (`jsonSchema` / `uiSchema`), SurveyJS (`pages`), or plain JSON Schema
 * are not converted; the builder starts empty so the form can be rebuilt in Form.io.
 */
export const normalizeStoredFormSchema = (schema) => {
  if (!isPlainObject(schema)) {
    return buildEmptyFormioForm();
  }
  if (!Array.isArray(schema.components)) {
    return buildEmptyFormioForm();
  }
  return buildFormioFormFromComponents(schema);
};
